import React, { useState, useRef } from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'; // Import the plugin for jsPDF
import IconButton from '../../elements/IconButton';
import Button from '../../elements/Button';

const Main = (props) => {
    const [loadedData, setLoadedData] = useState([]);
    const [stillGettingData, setStillGettingData] = useState(0);
    const isCancelled = useRef(false); // Used to track if fetching was cancelled

    const handleCancelFetch = () => {
        isCancelled.current = true; // Set flag to true when fetching is cancelled
    };

    const fetchAllData = (exportType) => {
        let skip = 0;
        const limit = 1;
        let allData = [];
        setStillGettingData(1);

        const fetchNext = () => {
            if (isCancelled.current) {
                console.log("Fetching has been cancelled by the user.");
                setStillGettingData(0); // Update state to reflect cancellation
                return;
            }
            getData(skip, limit, (hasMoreData, newData) => {
                if (newData[0].subagent_ID !== null) {
                    allData = allData.concat(newData);
                    skip += limit;
                    fetchNext();
                } else {
                    if (exportType === 'CSV') {
                        downloadCSV(allData, props.exportKeys, props.fileTitle);
                    } else if (exportType === 'PDF') {
                        downloadPDF(allData, props.exportKeys, props.fileTitle);
                    }
                    setStillGettingData(2);
                }
            });
        };

        fetchNext();
    };

    const getData = (skip, limit, onCompletion) => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(props.filterData)
        };

        props.tokenSafeAPIRequest(
            `${props.url}${props.specific ? '/' + props.specific : ''}?limit=${limit}&fetch_links=true&skip=${skip}&sort_field=${props.sort}&start_date=${props.calStartDate}&end_date=${props.calEndDate}&active_only=false`,
            requestOptions,
            '',
            (result, status) => {
                if ('postProcessing' in props) {
                    result = props.postProcessing(result);
                }

                console.log(result)

                if ('reports' in result) {
                    processResult(result.reports, onCompletion);
                } else if ('accounts' in result) {
                    processResult(result.accounts, onCompletion);
                } else if ('transactions' in result) {
                    processResult(result.transactions, onCompletion);
                } else if ('dealerships' in result) {
                    processResult(result.dealerships, onCompletion);
                } else if ('spiffs' in result) {
                    processResult(result.spiffs, onCompletion);
                } else if ('dppps_and_gap' in result) {
                    processResult(result.dppps_and_gap, onCompletion);
                } else {
                    processResult(result, onCompletion);
                }
            }
        );
    };

    const processResult = (data, onCompletion) => {
        if (data && data.length > 0) {
            setLoadedData((loadedData) => [...loadedData, ...data]);
            onCompletion(true, data);
        } else {
            onCompletion(false);
        }
    };

    function formatNumber(value) {
        try {
            // Attempt to convert the input to a number
            const num = parseFloat(value);
            // Check if the conversion resulted in a valid number
            if (!isNaN(num)) {
              // Use Intl.NumberFormat for US-style number formatting with two decimal places
              return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(num);
            } else {
              // Return a default value if the input is not a valid number
              return '0.00';
            }
          } catch (e) {
            // In case of any unexpected errors, return a default value
            return '0.00';
          }
    }

    const downloadCSV = (data, keys, filename = 'data.csv') => {
        console.log(keys)
        console.log(data)

        let csvContent = "";

        let IATableTotal = 0;
        let GLSTableTotal = 0;
        let normalTableTotal = 0;

        csvContent += "IA VSC\r\n";
        data.map((agent) => {
            if (agent.ia_vsc_accounts.length !== 0) {csvContent += "Agent,Account,Total Inputs,Total Outputs,Total\r\n"}
            agent.ia_vsc_accounts.forEach((acc) => {
                csvContent += `${agent.subagent_name}, ${acc.name},${acc.total_inputs},${acc.total_outputs},${acc.total_amount}\r\n`;
                IATableTotal += acc.total_amount;
            })
        })
        csvContent += (`IA - Total: ${IATableTotal}`);

        csvContent += "\r\n";
        csvContent += "\r\n";

        csvContent += "GLS Spiffs\r\n";
        data.map((agent) => {
            if (agent.gls_spiff_accounts.length !== 0) {csvContent += "Agent,Account,Total Inputs,Total Outputs,Total\r\n"}
            agent.gls_spiff_accounts.forEach((acc) => {
                csvContent += `${agent.subagent_name}, ${acc.name},${acc.total_inputs},${acc.total_outputs},${acc.total_amount}\r\n`;
                GLSTableTotal += acc.total_amount
            })
        })
        csvContent += (`GLS Spiffs - Total: ${GLSTableTotal}`);

        csvContent += "\r\n";
        csvContent += "\r\n";

        csvContent += "Normal Accounts\r\n";
        data.map((agent) => {
            if (agent.normal_accounts.length !== 0) {csvContent += "Agent,Account,Total Inputs,Total Outputs,Total\r\n"}
            agent.normal_accounts.forEach((acc) => {
                csvContent += `${agent.subagent_name}, ${acc.name},${acc.total_inputs},${acc.total_outputs},${acc.total_amount}\r\n`;
                normalTableTotal += acc.total_amount
            })
        })
        csvContent += (`Normal - Total: ${normalTableTotal}`);
    
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };
    

    const downloadPDF = (data, keys, filename = 'data.pdf') => {
        console.log(data)
        const doc = new jsPDF({orientation: 'landscape'});
    
        // Add title
        doc.text(props.fileTitle || 'Report', 20, 10);

        let pageCount = 1;

        const addPageNumbers = (doc) => {
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height;
            const pageWidth = pageSize.width;
    
            // Add footer with page number
            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text(
                    `Page ${i}`,
                    pageWidth - 30,
                    pageHeight - 10
                );
            }
        };

        let IATableTotal = 0;
        let GLSTableTotal = 0;
        let normalTableTotal = 0;

        const IATableData = [];
        const GLSTableData = []
        const normalTableData = []

        data.map((agent) => {
            console.log(agent)
            let agentIATotal = 0;
            let agentGLSTotal = 0;
            let agentNormalTotal = 0;

            agent.ia_vsc_accounts.forEach((acc) => {
                agentIATotal = agentIATotal + (acc.total_amount)
                IATableTotal += acc.total_amount
                IATableData.push([
                    agent.subagent_name,
                    acc.name,
                    formatNumber(acc.total_inputs),
                    formatNumber(acc.total_outputs),
                    formatNumber(acc.total_amount),
                ])
            })
            if (agentIATotal !== 0) {IATableData.push(['Total','','','',formatNumber(agentIATotal)])}

            agent.gls_spiff_accounts.forEach((acc) => {
                agentGLSTotal = agentGLSTotal + (acc.total_amount)
                GLSTableTotal += acc.total_amount;
                GLSTableData.push([
                    agent.subagent_name,
                    acc.name,
                    formatNumber(acc.total_inputs),
                    formatNumber(acc.total_outputs),
                    formatNumber(acc.total_amount),
                ])
            })
            if (agentGLSTotal !== 0) {GLSTableData.push(['Total','','','',formatNumber(agentGLSTotal)])}

            agent.normal_accounts.forEach((acc) => {
                agentNormalTotal = agentNormalTotal + (acc.total_amount)
                normalTableTotal += acc.total_amount;
                normalTableData.push([
                    agent.subagent_name,
                    acc.name,
                    formatNumber(acc.total_inputs),
                    formatNumber(acc.total_outputs),
                    formatNumber(acc.total_amount),
                ])
            })
            if (agentNormalTotal !== 0) {normalTableData.push(['Total','','','',formatNumber(agentNormalTotal)])}
        })

        doc.text(`IA VSC - Total: ${formatNumber(IATableTotal)}`, 14, 27.5);
    
        // Add Summary table with light grey border and no row fill color
        doc.autoTable({
            startY: 32.5,
            head: [['Agent', 'Account', 'Total Inputs', 'Total Outputs', 'Total']],
            body: IATableData,
            styles: {
                lineColor: [200, 200, 200], // Light grey border lines
                lineWidth: 0.1             // Thin border lines
            },
            bodyStyles: {
                fillColor: false             // Disable row fill color completely
            },
            headStyles: {
                fillColor: false,            // No background for header row
                textColor: 0,                // Black text
                lineColor: [200, 200, 200],  // Light grey border lines for header
                lineWidth: 0.1
            },
            tableLineColor: [200, 200, 200], // Light grey border around table
            tableLineWidth: 0.1,
            willDrawCell: function(data) {
                data.cell.styles.fillColor = false; // Override alternating row colors
            }
        });

        doc.text(`GLS Spiffs - Total: ${formatNumber(GLSTableTotal)}`, 14, doc.lastAutoTable.finalY + 10);
    
        // Add Summary table with light grey border and no row fill color
        doc.autoTable({
            startY: doc.lastAutoTable.finalY + 10,
            head: [['Agent', 'Account', 'Total Inputs', 'Total Outputs', 'Total']],
            body: GLSTableData,
            styles: {
                lineColor: [200, 200, 200], // Light grey border lines
                lineWidth: 0.1             // Thin border lines
            },
            bodyStyles: {
                fillColor: false             // Disable row fill color completely
            },
            headStyles: {
                fillColor: false,            // No background for header row
                textColor: 0,                // Black text
                lineColor: [200, 200, 200],  // Light grey border lines for header
                lineWidth: 0.1
            },
            tableLineColor: [200, 200, 200], // Light grey border around table
            tableLineWidth: 0.1,
            willDrawCell: function(data) {
                data.cell.styles.fillColor = false; // Override alternating row colors
            }
        });
        
        doc.text(`Normal Accounts - Total: ${formatNumber(normalTableTotal)}`, 14, doc.lastAutoTable.finalY + 10);
    
        // Add Summary table with light grey border and no row fill color
        doc.autoTable({
            startY: doc.lastAutoTable.finalY + 10,
            head: [['Agent', 'Account', 'Total Inputs', 'Total Outputs', 'Total']],
            body: normalTableData,
            styles: {
                lineColor: [200, 200, 200], // Light grey border lines
                lineWidth: 0.1             // Thin border lines
            },
            bodyStyles: {
                fillColor: false             // Disable row fill color completely
            },
            headStyles: {
                fillColor: false,            // No background for header row
                textColor: 0,                // Black text
                lineColor: [200, 200, 200],  // Light grey border lines for header
                lineWidth: 0.1
            },
            tableLineColor: [200, 200, 200], // Light grey border around table
            tableLineWidth: 0.1,
            willDrawCell: function(data) {
                data.cell.styles.fillColor = false; // Override alternating row colors
            }
        });

        pageCount++;

        addPageNumbers(doc);
    
        // Save the PDF
        doc.save(filename);
    };
    

    return (
        <div style={{ width: '360px', height: 'auto', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flexBasis: '10%', display: 'flex', flexDirection: 'row' }}>
                <span style={{ fontWeight: '500', fontSize: '20px', flexBasis: '99%' }}>Export Report</span>
                <IconButton img={false} colors={props.colors} Style={{ borderRadius: '3px', backgroundColor: props.colors.border, width: '24px' }} size="16px">
                    <div onClick={() => { handleCancelFetch(); props.setIsOpen() }} style={{ paddingLeft: '3px', paddingRight: '3px' }}><span onClick={() => { handleCancelFetch(); props.setIsOpen() }}>x</span></div>
                </IconButton>
            </div>
            <div style={{ flexBasis: '90%', display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                <span style={{ fontWeight: '500', fontSize: '16px' }}>Downloaded Rows: {loadedData.length}</span>
                <Button colors={props.colors} active={true} Style={{ marginTop: '10px' }} onClick={() => fetchAllData('CSV')}>Download All CSV</Button>
                <Button colors={props.colors} active={true} Style={{ marginTop: '10px' }} onClick={() => fetchAllData('PDF')}>Download All PDF</Button>
            </div>
        </div>
    );
};

export default Main;
